import React, { ReactElement, ReactNode, PropsWithChildren } from "react";
import Header from "./Header";
import Footer from "./Footer";

export type LayoutProps = {
  hasHeader?: boolean;
  hasFooter?: boolean;
  children?: ReactNode;
};

function Layout({
  hasHeader = true,
  hasFooter = true,
  children,
}: PropsWithChildren<LayoutProps>): ReactElement {
  return (
    <React.Fragment>
      {hasHeader && <Header />}
      <main>{children}</main>
      {hasFooter && <Footer />}
    </React.Fragment>
  );
}
export default Layout;
